import { InjectionToken } from '@angular/core';
import { AnswerRow } from '../domain/types';

/** Port for persisting answer rows to the backend. */
export interface AnswerRepository {
  /** Load all saved answers for a paper (by paperToProjectId). */
  loadFor(paperToProjectId: string): Promise<AnswerRow[]>;
  /** Submit (replace-all) the current answers for a paper. */
  submitAll(paperToProjectId: string, rows: AnswerRow[]): Promise<void>;
}

export const ANSWER_REPOSITORY = new InjectionToken<AnswerRepository>('ANSWER_REPOSITORY');
